import { render } from "./EnrollStudents.vue?vue&type=template&id=cb2193be"
import script from "./EnrollStudents.vue?vue&type=script&lang=js"
export * from "./EnrollStudents.vue?vue&type=script&lang=js"

import "./EnrollStudents.vue?vue&type=style&index=0&id=cb2193be&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__